import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { Row, Col, Form } from 'react-bootstrap';

import './UsuarioPermission.css';
import useGlobal from '../../../../store';
import { Auth } from '../../../../support';
import Loading from '../../../../facturotopia/loading/Loading';

const UsuarioPermissionsForm = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);

  const [checkedByTag, setCheckedByTag] = useState({});

  useEffect(() => {
    actions.getPermissions();

    return () => {
      props.onClean();
    };
  }, []); // eslint-disable-line

  const handleOnChange = (event) => {
    const { checked, value } = event.target;

    props.onChange({
      selected: {
        ...props.selected,
        [value]: checked,
      },
    });
  };

  const handleOnGroupTagChange = (event) => {
    const { checked, value } = event.target;

    const { data } = state;

    setCheckedByTag({
      ...checkedByTag,
      [value]: checked,
    });

    const grouped = _.groupBy(data, 'tag');

    const selected = {};

    for (const item of grouped[value]) {
      selected[item.id] = checked;
    }

    props.onChange({
      selected: {
        ...props.selected,
        ...selected,
      },
    });
  };

  const CheckboxListItem = (props) => {
    const { description = '', permission = '', id = '' } = props.data;
    const { selected = {} } = props;

    return (
      <>
        <Col
          sm={6}
          md={4}
        >
          <Form.Group
            controlId={id}
            key={id}
            className="custom-permissions-input"
          >
            <Form.Check
              type="switch"
              name={permission}
              label={description}
              checked={selected[id]}
              value={id}
              onChange={handleOnChange}
            />
          </Form.Group>
        </Col>
      </>
    );
  };

  const Tag = (props) => {
    const { tag, data, selected } = props;

    return (
      <>
        <Form.Group
          controlId={tag}
          className="pb-2 pt-1"
        >
          <Form.Check
            type="switch"
            name={tag}
            checked={checkedByTag[tag]}
            label={<strong className="text-muted">{tag.toUpperCase()}</strong>}
            value={tag}
            onChange={handleOnGroupTagChange}
          />
        </Form.Group>

        <Row className="pb-3">
          {data[tag].map((item) => (
            <CheckboxListItem
              key={item.id}
              data={item}
              selected={selected}
            />
          ))}
        </Row>
      </>
    );
  };

  if (state.busy) {
    return <Loading />;
  }

  const grouped = _.groupBy(state.data, 'tag');
  const tags = _.keys(grouped);

  const renderCheckbox = (tag) => {
    return (
      <Tag
        key={tag}
        tag={tag}
        data={grouped}
        selected={props.selected}
      />
    );
  };

  const auth = Auth.getData();
  const { user } = auth;
  const { roles } = user;

  const rol = roles[0].role;

  return (
    <div
      key={`inline-${'type'}`}
      className="mb-3"
    >
      {tags
        .filter((tag) => {
          if (rol === 'root' || rol === 'admin') {
            return tag;
          } else {
            return tag !== 'clientes' && tag !== 'pacs';
          }
        })
        .map(renderCheckbox)}
    </div>
  );
};

const mapState = (state) => {
  return state.app.usuarios.permissions;
};

const mapActions = (actions) => {
  return {
    getPermissions: actions.app.usuarios.permissions.permissions,
  };
};

export default UsuarioPermissionsForm;
